import { Input, TimePicker, Button, Table, Output } from "@ds/ds-snam/react";
import { INotificationAction } from "dataModels/stateModels/notification";
import { IMoveReservationParameters, IParametersFreezing, IShipper} from "dataModels/settings";
import moment from "moment";
import { getParametersFreezing, postShipper, putParametersFreezing } from "net/settings";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppUserRole, DsLayout, EntityType, IAppUserProfile, RequestStatus, RoutePath, TIME_FORMAT } from "shared/constants";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { RootState } from "state/appStore";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";
import useRequestStatus from "hooks/useRequestStatus";
import NoDataFound from "components/NoDataFound";
import { ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableSharedElements, getTableCellsHeaderSimple } from "shared/utils/dsComponentUtils";
import AddEntityButton from "components/AddEntityButton";
import { Input as TextInput } from "@ds/ds-snam/react";
import { useLocation, useNavigate } from "react-router";



const ShipperFormDetails:React.FC<{}> = ():JSX.Element=>{
    const { t } = useTranslation(['contract', 'app']);
    const location = useLocation();
    const navigate = useNavigate();

    return(
        <>
            <p className="pageTitle">
                {t('settings.shipperParameters.title1', { ns: 'contract' })} 
            </p>
            <div className="externalCustomerDataContainer">
                <Row>
                    <Col>
                        <Output
                            outputTitle={t('settings.shipperParameters.labels.0', { ns: 'contract' })}
                            outputText={location.state.shipper.shipperName}
                            style={{marginBottom:'16px'}}
                        ></Output>
                    </Col>
                    <Col>
                        <Output
                            outputTitle={t('settings.shipperParameters.labels.1', { ns: 'contract' })}
                            outputText={location.state.shipper.shipperCode}
                            style={{marginBottom:'16px'}}
                        ></Output>
                    </Col>
                </Row>
            </div>
            <div style={{float:'right',paddingTop:'20px',paddingBottom:'20px'}}>
                <Button
                    buttonType="button"
                    buttonUIVariant="secondary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.edit', { ns: 'app' })}//"modifica informazioni"
                    buttonIcon=""
                    isDisabled={false}
                    onClickEvent={(event: Event) => {
                        //console.log(formData)
                        navigate(RoutePath.SETTINGS_NEW_SHIPPER, {state:{shipper:location.state.shipper}});
                    }}
                />
            </div>
        </>
    );
}
export default ShipperFormDetails;

